import { render, staticRenderFns } from "./latestPredictions.vue?vue&type=template&id=7de3ca23&"
import script from "./latestPredictions.vue?vue&type=script&lang=js&"
export * from "./latestPredictions.vue?vue&type=script&lang=js&"
import style0 from "./latestPredictions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports